/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { CreateUserDto } from '../../models/create-user-dto';
import { UserDto } from '../../models/user-dto';

export interface PostUserControllerCreate$Params {

/**
 * 센터 초대 토큰
 */
  inviteToken?: string;
      body: CreateUserDto
}

export function postUserControllerCreate(http: HttpClient, rootUrl: string, params: PostUserControllerCreate$Params, context?: HttpContext): Observable<StrictHttpResponse<UserDto>> {
  const rb = new RequestBuilder(rootUrl, postUserControllerCreate.PATH, 'post');
  if (params) {
    rb.query('inviteToken', params.inviteToken, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<UserDto>;
    })
  );
}

postUserControllerCreate.PATH = '/api/user/signup';
